import { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import UndoIcon from '@mui/icons-material/Undo';
import LyftSettingsInput from "../components/LyftSettingsInput";

export const useLyftTableCols = ({ onConfirmModalOpen, page }) => {
  // Row-specific state management using store ID as key for independent editing
  const [editingRows, setEditingRows] = useState({}); // Track edit mode per store
  const [formSettings, setFormSettings] = useState({}); // Form data per store

  useEffect(() => {
    setEditingRows({})
    setEditingRows({})
  }, [page]);

  const handleFormSettings = (storeId, field, value) => {
    setFormSettings((prev) => ({
      ...prev,
      [storeId]: {
        ...prev[storeId],
        [field]: value
      }
    }));
  }

  const handleEdit = (storeId, rowData) => {
    setEditingRows(prev => ({ ...prev, [storeId]: true }));
    setFormSettings(prev => ({
      ...prev,
      [storeId]: {
        lyft_url: rowData?.lyft_url || '',
        lyft_program_id: rowData?.lyft_program_id || ''
      }
    }));
  }

  const handleCancel = (storeId) => {
    setFormSettings(prev => ({
      ...prev,
      [storeId]: {
        lyft_url: '',
        lyft_program_id: ''
      }
    }));
  }

  const handleUndo = (storeId, storeSettings) => {
    setFormSettings(prev => ({
      ...prev,
      [storeId]: {
        lyft_url: storeSettings?.lyft_url || '',
        lyft_program_id: storeSettings?.lyft_program_id || ''
      }
    }));
  }

  const handleSave = (formSettings, storeSettings) => {
    const storeId = storeSettings.value
    if(storeSettings?.lyft_url === formSettings.lyft_url && storeSettings?.lyft_program_id === formSettings.lyft_program_id) {
      setEditingRows(prev => ({ ...prev, [storeId]: false }));
      setFormSettings(prev => ({
        ...prev,
        [storeId]: {
          lyft_url: storeSettings?.lyft_url || '',
          lyft_program_id: storeSettings?.lyft_program_id || ''
        }
      }));
      return
    }
    onConfirmModalOpen(formSettings, storeId)
  }

  const cancelEditMode = (storeId) => {
    setEditingRows(prev => ({ ...prev, [storeId]: false }));
  }

  return {
    columns: [
    {
      id: 'value',
      label: "STORE NUMBER",
      sortable: true,
      cellContent: (rowData) => (rowData.label),
      showCol: true,
      rowClassName: 'table-lyft-store-col'
    }, 
    {
      id: 'lyft_url',
      label: "LYFT URL",
      sortable: false,
      cellContent: (rowData) => (
        <LyftSettingsInput
          initialValue={rowData?.lyft_url || ''}
          inputValue={formSettings[rowData.value]?.lyft_url}
          onChange={(value) => handleFormSettings(rowData.value, 'lyft_url', value)}
          handleEdit={() => handleEdit(rowData.value, rowData)}
          editMode={editingRows[rowData.value] || false}
        />
      ),
      showCol: true
    },
    {
      id: 'lyft_program_id',
      label: "LYFT PROGRAM ID",
      sortable: false,
      cellContent: (rowData) => (
        <LyftSettingsInput
          initialValue={rowData?.lyft_program_id || ''}
          inputValue={formSettings[rowData.value]?.lyft_program_id} 
          onChange={(value) => handleFormSettings(rowData.value, 'lyft_program_id', value)}
          handleEdit={() => handleEdit(rowData.value, rowData)}
          editMode={editingRows[rowData.value] || false}
          type="number"
          maxLength={19}
        />
      ),
      rowClassName: 'pr-0',
      showCol: true
    },
    {
      id: 'edit_settings',
      label: "",
      sortable: false,
      cellContent: (rowData) => (
        <Box className='flex items-center justify-center'>
          {editingRows[rowData.value] && (
            <>
              <IconButton size="small" onClick={() => handleCancel(rowData.value)}>
                <CancelIcon className="nav-help-button"/>
              </IconButton>
              <IconButton size="small" onClick={() => handleUndo(rowData.value, rowData)}>
                <UndoIcon/>
              </IconButton>
            </>
          )}
          <IconButton 
            size="small" 
            onClick={
              editingRows[rowData.value] 
                ? () => handleSave(formSettings[rowData.value], rowData) 
                : () => handleEdit(rowData.value, rowData)
            }
          >
            {editingRows[rowData.value] ? <SaveIcon color="primary" /> : <EditIcon/> }
          </IconButton>
        </Box>
      ),
      showCol: true,
      headerClassName: 'w-28',
      rowClassName: 'px-0'
    }
  ],
    handleUndo,
    cancelEditMode
  }
}